module.exports = require("escape-html");


//////////////////
// WEBPACK FOOTER
// external "escape-html"
// module id = 60
// module chunks = 0